import MessagesRouter from "./messages/router"
import NotificationsRouter from "./notifications/router"
import CustomersRouter from "./customers/router"
import QuotationsRouter from "./quotations/router"
import ProductsRouter from "./products/router"

const routers = [
  MessagesRouter,
  NotificationsRouter,
  CustomersRouter,
  QuotationsRouter,
  ProductsRouter,
]

export default routers
